const isExceptionLink = (pathname: string): boolean => {
  return ['/card-action/346', '/card-action/347', '/card-action/348'].includes(pathname);
};

export const isExternalUrl = (url: string): boolean => {
  try {
    const link = new URL(url, window.location.origin);

    return (
      link.origin !== window.location.origin ||
      (link.pathname.includes('/card-action/') && !isExceptionLink(link.pathname))
    );
  } catch (e) {
    return false;
  }
};
